import React, { SyntheticEvent } from "react";

import { Fieldset } from "./styles";
import { IProps } from "./interfaces";

const Form = ({ children, disabled, autoComplete }: IProps) => {
    const onSubmit = (e: SyntheticEvent) => {
        e.preventDefault();
    }
    return (
        <form onSubmit={onSubmit} noValidate autoComplete={autoComplete}>
            <Fieldset disabled={disabled}>{children}</Fieldset>
        </form>
    );
}

export default Form;
